export default __webpack_public_path__ + "static/promo-video-c3197e8ed9289030b5b94bef87f6d940.mp4";